import request from '@/config/request.js'
import common from '@/components/common/'
import ZoneHealthForm from './Form/index.vue'
import ZoneHealthScoreDialog from './ScoreDialog/index.vue'

const ApiHome = request.Home

const TERM_OPTIONS = [
  { label: '春季', value: '春季' },
  { label: '秋季', value: '秋季' },
  { label: '寒假', value: '寒假' },
  { label: '暑假', value: '暑假' }
]

const LEVEL_OPTIONS = [
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' }
]

const DEFAULT_OPTIONS = [
  { label: '默认数据', value: true },
  { label: '非默认数据', value: false }
]

function createSearchForm () {
  return {
    schoolYear: '',
    term: '',
    isDefault: '',
    level: '',
    assessDateRange: []
  }
}

function getPageContent (res) {
  if (res && Array.isArray(res.content)) return res.content
  if (res && res.data && Array.isArray(res.data.content)) return res.data.content
  if (res && Array.isArray(res.data)) return res.data
  return []
}

function getPageTotal (res, size) {
  if (res && typeof res.totalElements === 'number') return res.totalElements
  if (res && res.data && typeof res.data.totalElements === 'number') {
    return res.data.totalElements
  }
  if (res && res.pagination && typeof res.pagination.total === 'number') {
    return res.pagination.total
  }
  if (res && res.data && res.data.pagination &&
    typeof res.data.pagination.total === 'number') {
    return res.data.pagination.total
  }
  const list = getPageContent(res)
  return Array.isArray(list) ? list.length : size
}

export default {
  name: 'home-details',
  components: {
    ...common,
    ZoneHealthForm,
    ZoneHealthScoreDialog
  },
  data () {
    return {
      listLoading: false,
      seachShow: false,
      searchForm: createSearchForm(),
      termOptions: TERM_OPTIONS,
      levelOptions: LEVEL_OPTIONS,
      defaultOptions: DEFAULT_OPTIONS,
      tableList: [],
      formVisible: false,
      scoreDialogVisible: false,
      paginations: {
        current_page: 1,
        total: 0,
        page_size: 10,
        layout: 'total, prev, pager, next, jumper'
      }
    }
  },
  computed: {
    tableHeight () {
      return window.innerHeight - 310
    },
    loading () {
      return this.$store.state.global.ajax_loading
    }
  },
  created () {
    this.initData()
  },
  methods: {
    getRowKey (row) {
      return row && row.id ? row.id : ''
    },
    formatAmount (value) {
      if (value === '' || value === null || value === undefined) return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return num.toFixed(2)
    },
    formatPercent (value) {
      if (value === '' || value === null || value === undefined) return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return (num * 100).toFixed(2) + '%'
    },
    getDefaultLabel (value) {
      return value ? '是' : '否'
    },
    buildQueryData () {
      const query = {}
      const range = Array.isArray(this.searchForm.assessDateRange)
        ? this.searchForm.assessDateRange
        : []
      if (this.searchForm.schoolYear) query.schoolYear = this.searchForm.schoolYear
      if (this.searchForm.term) query.term = this.searchForm.term
      if (this.searchForm.level) query.level = this.searchForm.level
      if (this.searchForm.isDefault !== '' &&
        this.searchForm.isDefault !== null &&
        this.searchForm.isDefault !== undefined) {
        query.isDefault = this.searchForm.isDefault
      }
      if (range[0]) query.assessDateStart = range[0]
      if (range[1]) query.assessDateEnd = range[1]
      return query
    },
    buildPageParams () {
      return {
        page: this.paginations.current_page - 1,
        size: this.paginations.page_size,
        data: this.buildQueryData()
      }
    },
    initData () {
      this.listLoading = true
      ApiHome.zoneHealthPage.call(this, this.buildPageParams(), res => {
        const content = getPageContent(res)
        this.tableList = Array.isArray(content) ? content.map(item => {
          return Object.assign({}, item)
        }) : []
        this.paginations.total = getPageTotal(res, this.tableList.length)
        this.listLoading = false
      }, () => {
        this.listLoading = false
      })
    },
    onSearch () {
      this.paginations.current_page = 1
      this.initData()
    },
    onResetSearch () {
      this.searchForm = createSearchForm()
      this.paginations.current_page = 1
      this.initData()
    },
    openForm (row) {
      this.formVisible = true
      this.$nextTick(() => {
        const ref = this.$refs.zoneHealthFormRef
        if (ref && ref.init) {
          ref.init(row || {})
        }
      })
    },
    openScoreDialog (row) {
      if (!row || !row.id) return
      this.scoreDialogVisible = true
      this.$nextTick(() => {
        const ref = this.$refs.zoneHealthScoreDialogRef
        if (ref && ref.init) {
          ref.init(row)
        }
      })
    },
    onRecalculate (row) {
      if (!row || !row.id) return
      this.$confirm('确认重新计算该评估记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiHome.zoneHealthRecalculate.call(this, { id: row.id }, () => {
          this.$message({
            message: '重新计算成功',
            type: 'success'
          })
          this.initData()
        })
      }).catch(() => {})
    },
    onDelete (row) {
      if (!row || !row.id) return
      this.$confirm('确认删除该评估记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiHome.zoneHealthDelete.call(this, { id: row.id }, () => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          if (Array.isArray(this.tableList) &&
            this.tableList.length <= 1 &&
            this.paginations.current_page > 1) {
            this.paginations.current_page = this.paginations.current_page - 1
          }
          this.initData()
        })
      }).catch(() => {})
    }
  }
}
